import { styled } from "goober";
import {
  type ComponentPropsWithoutRef,
  type CSSProperties,
  forwardRef,
} from "react";
import { Icon } from "./Icon";

export const INFO_ICON_IDLE_OPACITY = 0.3;

const InfoIconRoot = styled("span")`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  cursor: pointer;
  opacity: var(--info-idle, ${INFO_ICON_IDLE_OPACITY});
  &:hover {
    opacity: 1;
  }
`;

type InfoIconProps = Omit<
  ComponentPropsWithoutRef<"span">,
  "color" | "children"
> & {
  color?: string;
  idleOpacity?: number;
};

export const InfoIcon = forwardRef<HTMLSpanElement, InfoIconProps>(
  ({ color, idleOpacity = INFO_ICON_IDLE_OPACITY, style, ...rest }, ref) => (
    <InfoIconRoot
      ref={ref}
      style={{ "--info-idle": idleOpacity, ...style } as CSSProperties}
      {...rest}
    >
      <Icon name="info" size={12} color={color} />
    </InfoIconRoot>
  )
);
InfoIcon.displayName = "InfoIcon";
